// source: assistant-deployment.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
goog.exportSymbol('proto.assistant_api.AssistantApiDeployment', null, global);
goog.exportSymbol('proto.assistant_api.AssistantDebuggerDeployment', null, global);
goog.exportSymbol('proto.assistant_api.AssistantPhoneDeployment', null, global);
goog.exportSymbol('proto.assistant_api.AssistantWebpluginDeployment', null, global);
goog.exportSymbol('proto.assistant_api.AssistantWhatsappDeployment', null, global);
goog.exportSymbol('proto.assistant_api.CreateAssistantDeploymentRequest', null, global);
goog.exportSymbol('proto.assistant_api.CreateAssistantDeploymentRequest.DeploymentCase', null, global);
goog.exportSymbol('proto.assistant_api.DeploymentAudioProvider', null, global);
goog.exportSymbol('proto.assistant_api.GetAssistantApiDeploymentResponse', null, global);
goog.exportSymbol('proto.assistant_api.GetAssistantDebuggerDeploymentResponse', null, global);
goog.exportSymbol('proto.assistant_api.GetAssistantDeploymentRequest', null, global);
goog.exportSymbol('proto.assistant_api.GetAssistantPhoneDeploymentResponse', null, global);
goog.exportSymbol('proto.assistant_api.GetAssistantWebpluginDeploymentResponse', null, global);
goog.exportSymbol('proto.assistant_api.GetAssistantWhatsappDeploymentResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.DeploymentAudioProvider = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.DeploymentAudioProvider.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.DeploymentAudioProvider, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.DeploymentAudioProvider.displayName = 'proto.assistant_api.DeploymentAudioProvider';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantWebpluginDeployment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.AssistantWebpluginDeployment.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.AssistantWebpluginDeployment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantWebpluginDeployment.displayName = 'proto.assistant_api.AssistantWebpluginDeployment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantPhoneDeployment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.AssistantPhoneDeployment.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.AssistantPhoneDeployment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantPhoneDeployment.displayName = 'proto.assistant_api.AssistantPhoneDeployment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantWhatsappDeployment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.AssistantWhatsappDeployment.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.AssistantWhatsappDeployment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantWhatsappDeployment.displayName = 'proto.assistant_api.AssistantWhatsappDeployment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantDebuggerDeployment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.AssistantDebuggerDeployment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantDebuggerDeployment.displayName = 'proto.assistant_api.AssistantDebuggerDeployment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantApiDeployment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.AssistantApiDeployment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantApiDeployment.displayName = 'proto.assistant_api.AssistantApiDeployment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.CreateAssistantDeploymentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.assistant_api.CreateAssistantDeploymentRequest.oneofGroups_);
};
goog.inherits(proto.assistant_api.CreateAssistantDeploymentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.CreateAssistantDeploymentRequest.displayName = 'proto.assistant_api.CreateAssistantDeploymentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAssistantApiDeploymentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.GetAssistantApiDeploymentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAssistantApiDeploymentResponse.displayName = 'proto.assistant_api.GetAssistantApiDeploymentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAssistantPhoneDeploymentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.GetAssistantPhoneDeploymentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAssistantPhoneDeploymentResponse.displayName = 'proto.assistant_api.GetAssistantPhoneDeploymentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAssistantWhatsappDeploymentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.GetAssistantWhatsappDeploymentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAssistantWhatsappDeploymentResponse.displayName = 'proto.assistant_api.GetAssistantWhatsappDeploymentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAssistantDebuggerDeploymentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.GetAssistantDebuggerDeploymentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAssistantDebuggerDeploymentResponse.displayName = 'proto.assistant_api.GetAssistantDebuggerDeploymentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAssistantWebpluginDeploymentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.GetAssistantWebpluginDeploymentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAssistantWebpluginDeploymentResponse.displayName = 'proto.assistant_api.GetAssistantWebpluginDeploymentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAssistantDeploymentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.GetAssistantDeploymentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAssistantDeploymentRequest.displayName = 'proto.assistant_api.GetAssistantDeploymentRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.DeploymentAudioProvider.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.DeploymentAudioProvider.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.DeploymentAudioProvider.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.DeploymentAudioProvider} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.DeploymentAudioProvider.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    audioprovider: jspb.Message.getFieldWithDefault(msg, 2, ""),
    audiooptionsList: jspb.Message.toObjectList(msg.getAudiooptionsList(),
    common_pb.Metadata.toObject, includeInstance),
    status: jspb.Message.getFieldWithDefault(msg, 5, ""),
    audiotype: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.DeploymentAudioProvider.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.DeploymentAudioProvider;
  return proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.DeploymentAudioProvider} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAudioprovider(value);
      break;
    case 3:
      var value = new common_pb.Metadata;
      reader.readMessage(value,common_pb.Metadata.deserializeBinaryFromReader);
      msg.addAudiooptions(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAudiotype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.DeploymentAudioProvider.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.DeploymentAudioProvider} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAudioprovider();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAudiooptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      common_pb.Metadata.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAudiotype();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.DeploymentAudioProvider.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.DeploymentAudioProvider} returns this
 */
proto.assistant_api.DeploymentAudioProvider.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string audioProvider = 2;
 * @return {string}
 */
proto.assistant_api.DeploymentAudioProvider.prototype.getAudioprovider = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.DeploymentAudioProvider} returns this
 */
proto.assistant_api.DeploymentAudioProvider.prototype.setAudioprovider = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Metadata audioOptions = 3;
 * @return {!Array<!proto.Metadata>}
 */
proto.assistant_api.DeploymentAudioProvider.prototype.getAudiooptionsList = function() {
  return /** @type{!Array<!proto.Metadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metadata, 3));
};


/**
 * @param {!Array<!proto.Metadata>} value
 * @return {!proto.assistant_api.DeploymentAudioProvider} returns this
*/
proto.assistant_api.DeploymentAudioProvider.prototype.setAudiooptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Metadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metadata}
 */
proto.assistant_api.DeploymentAudioProvider.prototype.addAudiooptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Metadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.DeploymentAudioProvider} returns this
 */
proto.assistant_api.DeploymentAudioProvider.prototype.clearAudiooptionsList = function() {
  return this.setAudiooptionsList([]);
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.assistant_api.DeploymentAudioProvider.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.DeploymentAudioProvider} returns this
 */
proto.assistant_api.DeploymentAudioProvider.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string audioType = 6;
 * @return {string}
 */
proto.assistant_api.DeploymentAudioProvider.prototype.getAudiotype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.DeploymentAudioProvider} returns this
 */
proto.assistant_api.DeploymentAudioProvider.prototype.setAudiotype = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.AssistantWebpluginDeployment.repeatedFields_ = [20];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantWebpluginDeployment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantWebpluginDeployment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantWebpluginDeployment.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    greeting: jspb.Message.getFieldWithDefault(msg, 10, ""),
    mistake: jspb.Message.getFieldWithDefault(msg, 11, ""),
    inputaudio: (f = msg.getInputaudio()) && proto.assistant_api.DeploymentAudioProvider.toObject(includeInstance, f),
    outputaudio: (f = msg.getOutputaudio()) && proto.assistant_api.DeploymentAudioProvider.toObject(includeInstance, f),
    suggestionList: (f = jspb.Message.getRepeatedField(msg, 20)) == null ? undefined : f,
    helpcenterenabled: jspb.Message.getBooleanFieldWithDefault(msg, 21, false),
    productcatalogenabled: jspb.Message.getBooleanFieldWithDefault(msg, 22, false),
    articlecatalogenabled: jspb.Message.getBooleanFieldWithDefault(msg, 23, false),
    uploadfileenabled: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 28, ""),
    maxsessionduration: jspb.Message.getFieldWithDefault(msg, 29, "0"),
    idealtimeout: jspb.Message.getFieldWithDefault(msg, 30, "0"),
    idealtimeoutmessage: jspb.Message.getFieldWithDefault(msg, 31, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment}
 */
proto.assistant_api.AssistantWebpluginDeployment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantWebpluginDeployment;
  return proto.assistant_api.AssistantWebpluginDeployment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantWebpluginDeployment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment}
 */
proto.assistant_api.AssistantWebpluginDeployment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setGreeting(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setMistake(value);
      break;
    case 13:
      var value = new proto.assistant_api.DeploymentAudioProvider;
      reader.readMessage(value,proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader);
      msg.setInputaudio(value);
      break;
    case 14:
      var value = new proto.assistant_api.DeploymentAudioProvider;
      reader.readMessage(value,proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader);
      msg.setOutputaudio(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.addSuggestion(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHelpcenterenabled(value);
      break;
    case 22:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setProductcatalogenabled(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setArticlecatalogenabled(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUploadfileenabled(value);
      break;
    case 26:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 27:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setMaxsessionduration(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setIdealtimeout(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdealtimeoutmessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantWebpluginDeployment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantWebpluginDeployment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantWebpluginDeployment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getInputaudio();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter
    );
  }
  f = message.getOutputaudio();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter
    );
  }
  f = message.getSuggestionList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      20,
      f
    );
  }
  f = message.getHelpcenterenabled();
  if (f) {
    writer.writeBool(
      21,
      f
    );
  }
  f = message.getProductcatalogenabled();
  if (f) {
    writer.writeBool(
      22,
      f
    );
  }
  f = message.getArticlecatalogenabled();
  if (f) {
    writer.writeBool(
      23,
      f
    );
  }
  f = message.getUploadfileenabled();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getMaxsessionduration();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      29,
      f
    );
  }
  f = message.getIdealtimeout();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      30,
      f
    );
  }
  f = message.getIdealtimeoutmessage();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantId = 5;
 * @return {string}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string greeting = 10;
 * @return {string}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getGreeting = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setGreeting = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.clearGreeting = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.hasGreeting = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string mistake = 11;
 * @return {string}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getMistake = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setMistake = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.clearMistake = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.hasMistake = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional DeploymentAudioProvider inputAudio = 13;
 * @return {?proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getInputaudio = function() {
  return /** @type{?proto.assistant_api.DeploymentAudioProvider} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.DeploymentAudioProvider, 13));
};


/**
 * @param {?proto.assistant_api.DeploymentAudioProvider|undefined} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
*/
proto.assistant_api.AssistantWebpluginDeployment.prototype.setInputaudio = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.clearInputaudio = function() {
  return this.setInputaudio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.hasInputaudio = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional DeploymentAudioProvider outputAudio = 14;
 * @return {?proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getOutputaudio = function() {
  return /** @type{?proto.assistant_api.DeploymentAudioProvider} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.DeploymentAudioProvider, 14));
};


/**
 * @param {?proto.assistant_api.DeploymentAudioProvider|undefined} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
*/
proto.assistant_api.AssistantWebpluginDeployment.prototype.setOutputaudio = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.clearOutputaudio = function() {
  return this.setOutputaudio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.hasOutputaudio = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * repeated string suggestion = 20;
 * @return {!Array<string>}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getSuggestionList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 20));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setSuggestionList = function(value) {
  return jspb.Message.setField(this, 20, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.addSuggestion = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 20, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.clearSuggestionList = function() {
  return this.setSuggestionList([]);
};


/**
 * optional bool helpCenterEnabled = 21;
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getHelpcenterenabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setHelpcenterenabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 21, value);
};


/**
 * optional bool productCatalogEnabled = 22;
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getProductcatalogenabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 22, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setProductcatalogenabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 22, value);
};


/**
 * optional bool articleCatalogEnabled = 23;
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getArticlecatalogenabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setArticlecatalogenabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 23, value);
};


/**
 * optional bool uploadFileEnabled = 24;
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getUploadfileenabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setUploadfileenabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional google.protobuf.Timestamp createdDate = 26;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 26));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
*/
proto.assistant_api.AssistantWebpluginDeployment.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 27;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 27));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
*/
proto.assistant_api.AssistantWebpluginDeployment.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional string status = 28;
 * @return {string}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional uint64 maxSessionDuration = 29;
 * @return {string}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getMaxsessionduration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setMaxsessionduration = function(value) {
  return jspb.Message.setProto3StringIntField(this, 29, value);
};


/**
 * optional uint64 idealTimeout = 30;
 * @return {string}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getIdealtimeout = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setIdealtimeout = function(value) {
  return jspb.Message.setProto3StringIntField(this, 30, value);
};


/**
 * optional string idealTimeoutMessage = 31;
 * @return {string}
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.getIdealtimeoutmessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWebpluginDeployment} returns this
 */
proto.assistant_api.AssistantWebpluginDeployment.prototype.setIdealtimeoutmessage = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.AssistantPhoneDeployment.repeatedFields_ = [17];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantPhoneDeployment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantPhoneDeployment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantPhoneDeployment.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    greeting: jspb.Message.getFieldWithDefault(msg, 10, ""),
    mistake: jspb.Message.getFieldWithDefault(msg, 11, ""),
    inputaudio: (f = msg.getInputaudio()) && proto.assistant_api.DeploymentAudioProvider.toObject(includeInstance, f),
    outputaudio: (f = msg.getOutputaudio()) && proto.assistant_api.DeploymentAudioProvider.toObject(includeInstance, f),
    phoneprovidername: jspb.Message.getFieldWithDefault(msg, 15, ""),
    phoneoptionsList: jspb.Message.toObjectList(msg.getPhoneoptionsList(),
    common_pb.Metadata.toObject, includeInstance),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 28, ""),
    maxsessionduration: jspb.Message.getFieldWithDefault(msg, 29, "0"),
    idealtimeout: jspb.Message.getFieldWithDefault(msg, 30, "0"),
    idealtimeoutmessage: jspb.Message.getFieldWithDefault(msg, 31, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantPhoneDeployment}
 */
proto.assistant_api.AssistantPhoneDeployment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantPhoneDeployment;
  return proto.assistant_api.AssistantPhoneDeployment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantPhoneDeployment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantPhoneDeployment}
 */
proto.assistant_api.AssistantPhoneDeployment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setGreeting(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setMistake(value);
      break;
    case 13:
      var value = new proto.assistant_api.DeploymentAudioProvider;
      reader.readMessage(value,proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader);
      msg.setInputaudio(value);
      break;
    case 14:
      var value = new proto.assistant_api.DeploymentAudioProvider;
      reader.readMessage(value,proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader);
      msg.setOutputaudio(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneprovidername(value);
      break;
    case 17:
      var value = new common_pb.Metadata;
      reader.readMessage(value,common_pb.Metadata.deserializeBinaryFromReader);
      msg.addPhoneoptions(value);
      break;
    case 26:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 27:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setMaxsessionduration(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setIdealtimeout(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdealtimeoutmessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantPhoneDeployment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantPhoneDeployment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantPhoneDeployment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getInputaudio();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter
    );
  }
  f = message.getOutputaudio();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter
    );
  }
  f = message.getPhoneprovidername();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getPhoneoptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      17,
      f,
      common_pb.Metadata.serializeBinaryToWriter
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getMaxsessionduration();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      29,
      f
    );
  }
  f = message.getIdealtimeout();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      30,
      f
    );
  }
  f = message.getIdealtimeoutmessage();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantId = 5;
 * @return {string}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional string greeting = 10;
 * @return {string}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getGreeting = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.setGreeting = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.clearGreeting = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.hasGreeting = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string mistake = 11;
 * @return {string}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getMistake = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.setMistake = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.clearMistake = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.hasMistake = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional DeploymentAudioProvider inputAudio = 13;
 * @return {?proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getInputaudio = function() {
  return /** @type{?proto.assistant_api.DeploymentAudioProvider} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.DeploymentAudioProvider, 13));
};


/**
 * @param {?proto.assistant_api.DeploymentAudioProvider|undefined} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
*/
proto.assistant_api.AssistantPhoneDeployment.prototype.setInputaudio = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.clearInputaudio = function() {
  return this.setInputaudio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.hasInputaudio = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional DeploymentAudioProvider outputAudio = 14;
 * @return {?proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getOutputaudio = function() {
  return /** @type{?proto.assistant_api.DeploymentAudioProvider} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.DeploymentAudioProvider, 14));
};


/**
 * @param {?proto.assistant_api.DeploymentAudioProvider|undefined} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
*/
proto.assistant_api.AssistantPhoneDeployment.prototype.setOutputaudio = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.clearOutputaudio = function() {
  return this.setOutputaudio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.hasOutputaudio = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string phoneProviderName = 15;
 * @return {string}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getPhoneprovidername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.setPhoneprovidername = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * repeated Metadata phoneOptions = 17;
 * @return {!Array<!proto.Metadata>}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getPhoneoptionsList = function() {
  return /** @type{!Array<!proto.Metadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metadata, 17));
};


/**
 * @param {!Array<!proto.Metadata>} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
*/
proto.assistant_api.AssistantPhoneDeployment.prototype.setPhoneoptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 17, value);
};


/**
 * @param {!proto.Metadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metadata}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.addPhoneoptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 17, opt_value, proto.Metadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.clearPhoneoptionsList = function() {
  return this.setPhoneoptionsList([]);
};


/**
 * optional google.protobuf.Timestamp createdDate = 26;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 26));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
*/
proto.assistant_api.AssistantPhoneDeployment.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 27;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 27));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
*/
proto.assistant_api.AssistantPhoneDeployment.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional string status = 28;
 * @return {string}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional uint64 maxSessionDuration = 29;
 * @return {string}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getMaxsessionduration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.setMaxsessionduration = function(value) {
  return jspb.Message.setProto3StringIntField(this, 29, value);
};


/**
 * optional uint64 idealTimeout = 30;
 * @return {string}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getIdealtimeout = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.setIdealtimeout = function(value) {
  return jspb.Message.setProto3StringIntField(this, 30, value);
};


/**
 * optional string idealTimeoutMessage = 31;
 * @return {string}
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.getIdealtimeoutmessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantPhoneDeployment} returns this
 */
proto.assistant_api.AssistantPhoneDeployment.prototype.setIdealtimeoutmessage = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.AssistantWhatsappDeployment.repeatedFields_ = [17];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantWhatsappDeployment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantWhatsappDeployment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantWhatsappDeployment.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    greeting: jspb.Message.getFieldWithDefault(msg, 10, ""),
    mistake: jspb.Message.getFieldWithDefault(msg, 11, ""),
    inputaudio: (f = msg.getInputaudio()) && proto.assistant_api.DeploymentAudioProvider.toObject(includeInstance, f),
    outputaudio: (f = msg.getOutputaudio()) && proto.assistant_api.DeploymentAudioProvider.toObject(includeInstance, f),
    whatsappprovidername: jspb.Message.getFieldWithDefault(msg, 15, ""),
    whatsappoptionsList: jspb.Message.toObjectList(msg.getWhatsappoptionsList(),
    common_pb.Metadata.toObject, includeInstance),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 28, ""),
    maxsessionduration: jspb.Message.getFieldWithDefault(msg, 29, "0"),
    idealtimeout: jspb.Message.getFieldWithDefault(msg, 30, "0"),
    idealtimeoutmessage: jspb.Message.getFieldWithDefault(msg, 31, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantWhatsappDeployment}
 */
proto.assistant_api.AssistantWhatsappDeployment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantWhatsappDeployment;
  return proto.assistant_api.AssistantWhatsappDeployment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantWhatsappDeployment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantWhatsappDeployment}
 */
proto.assistant_api.AssistantWhatsappDeployment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setGreeting(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setMistake(value);
      break;
    case 13:
      var value = new proto.assistant_api.DeploymentAudioProvider;
      reader.readMessage(value,proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader);
      msg.setInputaudio(value);
      break;
    case 14:
      var value = new proto.assistant_api.DeploymentAudioProvider;
      reader.readMessage(value,proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader);
      msg.setOutputaudio(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setWhatsappprovidername(value);
      break;
    case 17:
      var value = new common_pb.Metadata;
      reader.readMessage(value,common_pb.Metadata.deserializeBinaryFromReader);
      msg.addWhatsappoptions(value);
      break;
    case 26:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 27:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setMaxsessionduration(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setIdealtimeout(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdealtimeoutmessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantWhatsappDeployment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantWhatsappDeployment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantWhatsappDeployment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getInputaudio();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter
    );
  }
  f = message.getOutputaudio();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter
    );
  }
  f = message.getWhatsappprovidername();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getWhatsappoptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      17,
      f,
      common_pb.Metadata.serializeBinaryToWriter
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getMaxsessionduration();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      29,
      f
    );
  }
  f = message.getIdealtimeout();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      30,
      f
    );
  }
  f = message.getIdealtimeoutmessage();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantId = 5;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string greeting = 10;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getGreeting = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setGreeting = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.clearGreeting = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.hasGreeting = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string mistake = 11;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getMistake = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setMistake = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.clearMistake = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.hasMistake = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional DeploymentAudioProvider inputAudio = 13;
 * @return {?proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getInputaudio = function() {
  return /** @type{?proto.assistant_api.DeploymentAudioProvider} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.DeploymentAudioProvider, 13));
};


/**
 * @param {?proto.assistant_api.DeploymentAudioProvider|undefined} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
*/
proto.assistant_api.AssistantWhatsappDeployment.prototype.setInputaudio = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.clearInputaudio = function() {
  return this.setInputaudio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.hasInputaudio = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional DeploymentAudioProvider outputAudio = 14;
 * @return {?proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getOutputaudio = function() {
  return /** @type{?proto.assistant_api.DeploymentAudioProvider} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.DeploymentAudioProvider, 14));
};


/**
 * @param {?proto.assistant_api.DeploymentAudioProvider|undefined} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
*/
proto.assistant_api.AssistantWhatsappDeployment.prototype.setOutputaudio = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.clearOutputaudio = function() {
  return this.setOutputaudio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.hasOutputaudio = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string whatsappProviderName = 15;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getWhatsappprovidername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setWhatsappprovidername = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * repeated Metadata whatsappOptions = 17;
 * @return {!Array<!proto.Metadata>}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getWhatsappoptionsList = function() {
  return /** @type{!Array<!proto.Metadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metadata, 17));
};


/**
 * @param {!Array<!proto.Metadata>} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
*/
proto.assistant_api.AssistantWhatsappDeployment.prototype.setWhatsappoptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 17, value);
};


/**
 * @param {!proto.Metadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metadata}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.addWhatsappoptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 17, opt_value, proto.Metadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.clearWhatsappoptionsList = function() {
  return this.setWhatsappoptionsList([]);
};


/**
 * optional google.protobuf.Timestamp createdDate = 26;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 26));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
*/
proto.assistant_api.AssistantWhatsappDeployment.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 27;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 27));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
*/
proto.assistant_api.AssistantWhatsappDeployment.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional string status = 28;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional uint64 maxSessionDuration = 29;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getMaxsessionduration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setMaxsessionduration = function(value) {
  return jspb.Message.setProto3StringIntField(this, 29, value);
};


/**
 * optional uint64 idealTimeout = 30;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getIdealtimeout = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setIdealtimeout = function(value) {
  return jspb.Message.setProto3StringIntField(this, 30, value);
};


/**
 * optional string idealTimeoutMessage = 31;
 * @return {string}
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.getIdealtimeoutmessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantWhatsappDeployment} returns this
 */
proto.assistant_api.AssistantWhatsappDeployment.prototype.setIdealtimeoutmessage = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantDebuggerDeployment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantDebuggerDeployment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantDebuggerDeployment.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    name: jspb.Message.getFieldWithDefault(msg, 6, ""),
    greeting: jspb.Message.getFieldWithDefault(msg, 10, ""),
    mistake: jspb.Message.getFieldWithDefault(msg, 11, ""),
    inputaudio: (f = msg.getInputaudio()) && proto.assistant_api.DeploymentAudioProvider.toObject(includeInstance, f),
    outputaudio: (f = msg.getOutputaudio()) && proto.assistant_api.DeploymentAudioProvider.toObject(includeInstance, f),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 28, ""),
    maxsessionduration: jspb.Message.getFieldWithDefault(msg, 29, "0"),
    idealtimeout: jspb.Message.getFieldWithDefault(msg, 30, "0"),
    idealtimeoutmessage: jspb.Message.getFieldWithDefault(msg, 31, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantDebuggerDeployment}
 */
proto.assistant_api.AssistantDebuggerDeployment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantDebuggerDeployment;
  return proto.assistant_api.AssistantDebuggerDeployment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantDebuggerDeployment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantDebuggerDeployment}
 */
proto.assistant_api.AssistantDebuggerDeployment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setGreeting(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setMistake(value);
      break;
    case 13:
      var value = new proto.assistant_api.DeploymentAudioProvider;
      reader.readMessage(value,proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader);
      msg.setInputaudio(value);
      break;
    case 14:
      var value = new proto.assistant_api.DeploymentAudioProvider;
      reader.readMessage(value,proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader);
      msg.setOutputaudio(value);
      break;
    case 26:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 27:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setMaxsessionduration(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setIdealtimeout(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdealtimeoutmessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantDebuggerDeployment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantDebuggerDeployment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantDebuggerDeployment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getInputaudio();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter
    );
  }
  f = message.getOutputaudio();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getMaxsessionduration();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      29,
      f
    );
  }
  f = message.getIdealtimeout();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      30,
      f
    );
  }
  f = message.getIdealtimeoutmessage();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantId = 5;
 * @return {string}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional string name = 6;
 * @return {string}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string greeting = 10;
 * @return {string}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getGreeting = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.setGreeting = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.clearGreeting = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.hasGreeting = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string mistake = 11;
 * @return {string}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getMistake = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.setMistake = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.clearMistake = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.hasMistake = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional DeploymentAudioProvider inputAudio = 13;
 * @return {?proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getInputaudio = function() {
  return /** @type{?proto.assistant_api.DeploymentAudioProvider} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.DeploymentAudioProvider, 13));
};


/**
 * @param {?proto.assistant_api.DeploymentAudioProvider|undefined} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
*/
proto.assistant_api.AssistantDebuggerDeployment.prototype.setInputaudio = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.clearInputaudio = function() {
  return this.setInputaudio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.hasInputaudio = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional DeploymentAudioProvider outputAudio = 14;
 * @return {?proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getOutputaudio = function() {
  return /** @type{?proto.assistant_api.DeploymentAudioProvider} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.DeploymentAudioProvider, 14));
};


/**
 * @param {?proto.assistant_api.DeploymentAudioProvider|undefined} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
*/
proto.assistant_api.AssistantDebuggerDeployment.prototype.setOutputaudio = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.clearOutputaudio = function() {
  return this.setOutputaudio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.hasOutputaudio = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.Timestamp createdDate = 26;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 26));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
*/
proto.assistant_api.AssistantDebuggerDeployment.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 27;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 27));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
*/
proto.assistant_api.AssistantDebuggerDeployment.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional string status = 28;
 * @return {string}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional uint64 maxSessionDuration = 29;
 * @return {string}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getMaxsessionduration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.setMaxsessionduration = function(value) {
  return jspb.Message.setProto3StringIntField(this, 29, value);
};


/**
 * optional uint64 idealTimeout = 30;
 * @return {string}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getIdealtimeout = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.setIdealtimeout = function(value) {
  return jspb.Message.setProto3StringIntField(this, 30, value);
};


/**
 * optional string idealTimeoutMessage = 31;
 * @return {string}
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.getIdealtimeoutmessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantDebuggerDeployment} returns this
 */
proto.assistant_api.AssistantDebuggerDeployment.prototype.setIdealtimeoutmessage = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantApiDeployment.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantApiDeployment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantApiDeployment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantApiDeployment.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantid: jspb.Message.getFieldWithDefault(msg, 5, "0"),
    greeting: jspb.Message.getFieldWithDefault(msg, 10, ""),
    mistake: jspb.Message.getFieldWithDefault(msg, 11, ""),
    inputaudio: (f = msg.getInputaudio()) && proto.assistant_api.DeploymentAudioProvider.toObject(includeInstance, f),
    outputaudio: (f = msg.getOutputaudio()) && proto.assistant_api.DeploymentAudioProvider.toObject(includeInstance, f),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 28, ""),
    maxsessionduration: jspb.Message.getFieldWithDefault(msg, 29, "0"),
    idealtimeout: jspb.Message.getFieldWithDefault(msg, 30, "0"),
    idealtimeoutmessage: jspb.Message.getFieldWithDefault(msg, 31, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantApiDeployment}
 */
proto.assistant_api.AssistantApiDeployment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantApiDeployment;
  return proto.assistant_api.AssistantApiDeployment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantApiDeployment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantApiDeployment}
 */
proto.assistant_api.AssistantApiDeployment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setGreeting(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setMistake(value);
      break;
    case 13:
      var value = new proto.assistant_api.DeploymentAudioProvider;
      reader.readMessage(value,proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader);
      msg.setInputaudio(value);
      break;
    case 14:
      var value = new proto.assistant_api.DeploymentAudioProvider;
      reader.readMessage(value,proto.assistant_api.DeploymentAudioProvider.deserializeBinaryFromReader);
      msg.setOutputaudio(value);
      break;
    case 26:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 27:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setMaxsessionduration(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setIdealtimeout(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdealtimeoutmessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantApiDeployment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantApiDeployment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantApiDeployment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantApiDeployment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeString(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getInputaudio();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter
    );
  }
  f = message.getOutputaudio();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.assistant_api.DeploymentAudioProvider.serializeBinaryToWriter
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getMaxsessionduration();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      29,
      f
    );
  }
  f = message.getIdealtimeout();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      30,
      f
    );
  }
  f = message.getIdealtimeoutmessage();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantId = 5;
 * @return {string}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};


/**
 * optional string greeting = 10;
 * @return {string}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getGreeting = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.setGreeting = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.clearGreeting = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantApiDeployment.prototype.hasGreeting = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string mistake = 11;
 * @return {string}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getMistake = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.setMistake = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.clearMistake = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantApiDeployment.prototype.hasMistake = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional DeploymentAudioProvider inputAudio = 13;
 * @return {?proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getInputaudio = function() {
  return /** @type{?proto.assistant_api.DeploymentAudioProvider} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.DeploymentAudioProvider, 13));
};


/**
 * @param {?proto.assistant_api.DeploymentAudioProvider|undefined} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
*/
proto.assistant_api.AssistantApiDeployment.prototype.setInputaudio = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.clearInputaudio = function() {
  return this.setInputaudio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantApiDeployment.prototype.hasInputaudio = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional DeploymentAudioProvider outputAudio = 14;
 * @return {?proto.assistant_api.DeploymentAudioProvider}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getOutputaudio = function() {
  return /** @type{?proto.assistant_api.DeploymentAudioProvider} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.DeploymentAudioProvider, 14));
};


/**
 * @param {?proto.assistant_api.DeploymentAudioProvider|undefined} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
*/
proto.assistant_api.AssistantApiDeployment.prototype.setOutputaudio = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.clearOutputaudio = function() {
  return this.setOutputaudio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantApiDeployment.prototype.hasOutputaudio = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.Timestamp createdDate = 26;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 26));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
*/
proto.assistant_api.AssistantApiDeployment.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantApiDeployment.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 27;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 27));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
*/
proto.assistant_api.AssistantApiDeployment.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantApiDeployment.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional string status = 28;
 * @return {string}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional uint64 maxSessionDuration = 29;
 * @return {string}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getMaxsessionduration = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.setMaxsessionduration = function(value) {
  return jspb.Message.setProto3StringIntField(this, 29, value);
};


/**
 * optional uint64 idealTimeout = 30;
 * @return {string}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getIdealtimeout = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.setIdealtimeout = function(value) {
  return jspb.Message.setProto3StringIntField(this, 30, value);
};


/**
 * optional string idealTimeoutMessage = 31;
 * @return {string}
 */
proto.assistant_api.AssistantApiDeployment.prototype.getIdealtimeoutmessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantApiDeployment} returns this
 */
proto.assistant_api.AssistantApiDeployment.prototype.setIdealtimeoutmessage = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.assistant_api.CreateAssistantDeploymentRequest.oneofGroups_ = [[1,2,3,4,5]];

/**
 * @enum {number}
 */
proto.assistant_api.CreateAssistantDeploymentRequest.DeploymentCase = {
  DEPLOYMENT_NOT_SET: 0,
  API: 1,
  DEBUGGER: 2,
  WHATSAPP: 3,
  PHONE: 4,
  PLUGIN: 5
};

/**
 * @return {proto.assistant_api.CreateAssistantDeploymentRequest.DeploymentCase}
 */
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.getDeploymentCase = function() {
  return /** @type {proto.assistant_api.CreateAssistantDeploymentRequest.DeploymentCase} */(jspb.Message.computeOneofCase(this, proto.assistant_api.CreateAssistantDeploymentRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.CreateAssistantDeploymentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.CreateAssistantDeploymentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantDeploymentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    api: (f = msg.getApi()) && proto.assistant_api.AssistantApiDeployment.toObject(includeInstance, f),
    pb_debugger: (f = msg.getDebugger()) && proto.assistant_api.AssistantDebuggerDeployment.toObject(includeInstance, f),
    whatsapp: (f = msg.getWhatsapp()) && proto.assistant_api.AssistantWhatsappDeployment.toObject(includeInstance, f),
    phone: (f = msg.getPhone()) && proto.assistant_api.AssistantPhoneDeployment.toObject(includeInstance, f),
    plugin: (f = msg.getPlugin()) && proto.assistant_api.AssistantWebpluginDeployment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.CreateAssistantDeploymentRequest}
 */
proto.assistant_api.CreateAssistantDeploymentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.CreateAssistantDeploymentRequest;
  return proto.assistant_api.CreateAssistantDeploymentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.CreateAssistantDeploymentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.CreateAssistantDeploymentRequest}
 */
proto.assistant_api.CreateAssistantDeploymentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.assistant_api.AssistantApiDeployment;
      reader.readMessage(value,proto.assistant_api.AssistantApiDeployment.deserializeBinaryFromReader);
      msg.setApi(value);
      break;
    case 2:
      var value = new proto.assistant_api.AssistantDebuggerDeployment;
      reader.readMessage(value,proto.assistant_api.AssistantDebuggerDeployment.deserializeBinaryFromReader);
      msg.setDebugger(value);
      break;
    case 3:
      var value = new proto.assistant_api.AssistantWhatsappDeployment;
      reader.readMessage(value,proto.assistant_api.AssistantWhatsappDeployment.deserializeBinaryFromReader);
      msg.setWhatsapp(value);
      break;
    case 4:
      var value = new proto.assistant_api.AssistantPhoneDeployment;
      reader.readMessage(value,proto.assistant_api.AssistantPhoneDeployment.deserializeBinaryFromReader);
      msg.setPhone(value);
      break;
    case 5:
      var value = new proto.assistant_api.AssistantWebpluginDeployment;
      reader.readMessage(value,proto.assistant_api.AssistantWebpluginDeployment.deserializeBinaryFromReader);
      msg.setPlugin(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.CreateAssistantDeploymentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.CreateAssistantDeploymentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantDeploymentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApi();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.assistant_api.AssistantApiDeployment.serializeBinaryToWriter
    );
  }
  f = message.getDebugger();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.assistant_api.AssistantDebuggerDeployment.serializeBinaryToWriter
    );
  }
  f = message.getWhatsapp();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.assistant_api.AssistantWhatsappDeployment.serializeBinaryToWriter
    );
  }
  f = message.getPhone();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.assistant_api.AssistantPhoneDeployment.serializeBinaryToWriter
    );
  }
  f = message.getPlugin();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.assistant_api.AssistantWebpluginDeployment.serializeBinaryToWriter
    );
  }
};


/**
 * optional AssistantApiDeployment api = 1;
 * @return {?proto.assistant_api.AssistantApiDeployment}
 */
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.getApi = function() {
  return /** @type{?proto.assistant_api.AssistantApiDeployment} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantApiDeployment, 1));
};


/**
 * @param {?proto.assistant_api.AssistantApiDeployment|undefined} value
 * @return {!proto.assistant_api.CreateAssistantDeploymentRequest} returns this
*/
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.setApi = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.assistant_api.CreateAssistantDeploymentRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.CreateAssistantDeploymentRequest} returns this
 */
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.clearApi = function() {
  return this.setApi(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.hasApi = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional AssistantDebuggerDeployment debugger = 2;
 * @return {?proto.assistant_api.AssistantDebuggerDeployment}
 */
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.getDebugger = function() {
  return /** @type{?proto.assistant_api.AssistantDebuggerDeployment} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantDebuggerDeployment, 2));
};


/**
 * @param {?proto.assistant_api.AssistantDebuggerDeployment|undefined} value
 * @return {!proto.assistant_api.CreateAssistantDeploymentRequest} returns this
*/
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.setDebugger = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.assistant_api.CreateAssistantDeploymentRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.CreateAssistantDeploymentRequest} returns this
 */
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.clearDebugger = function() {
  return this.setDebugger(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.hasDebugger = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AssistantWhatsappDeployment whatsapp = 3;
 * @return {?proto.assistant_api.AssistantWhatsappDeployment}
 */
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.getWhatsapp = function() {
  return /** @type{?proto.assistant_api.AssistantWhatsappDeployment} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantWhatsappDeployment, 3));
};


/**
 * @param {?proto.assistant_api.AssistantWhatsappDeployment|undefined} value
 * @return {!proto.assistant_api.CreateAssistantDeploymentRequest} returns this
*/
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.setWhatsapp = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.assistant_api.CreateAssistantDeploymentRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.CreateAssistantDeploymentRequest} returns this
 */
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.clearWhatsapp = function() {
  return this.setWhatsapp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.hasWhatsapp = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional AssistantPhoneDeployment phone = 4;
 * @return {?proto.assistant_api.AssistantPhoneDeployment}
 */
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.getPhone = function() {
  return /** @type{?proto.assistant_api.AssistantPhoneDeployment} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantPhoneDeployment, 4));
};


/**
 * @param {?proto.assistant_api.AssistantPhoneDeployment|undefined} value
 * @return {!proto.assistant_api.CreateAssistantDeploymentRequest} returns this
*/
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.setPhone = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.assistant_api.CreateAssistantDeploymentRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.CreateAssistantDeploymentRequest} returns this
 */
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.clearPhone = function() {
  return this.setPhone(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.hasPhone = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional AssistantWebpluginDeployment plugin = 5;
 * @return {?proto.assistant_api.AssistantWebpluginDeployment}
 */
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.getPlugin = function() {
  return /** @type{?proto.assistant_api.AssistantWebpluginDeployment} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantWebpluginDeployment, 5));
};


/**
 * @param {?proto.assistant_api.AssistantWebpluginDeployment|undefined} value
 * @return {!proto.assistant_api.CreateAssistantDeploymentRequest} returns this
*/
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.setPlugin = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.assistant_api.CreateAssistantDeploymentRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.CreateAssistantDeploymentRequest} returns this
 */
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.clearPlugin = function() {
  return this.setPlugin(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.CreateAssistantDeploymentRequest.prototype.hasPlugin = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAssistantApiDeploymentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAssistantApiDeploymentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAssistantApiDeploymentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantApiDeploymentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && proto.assistant_api.AssistantApiDeployment.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAssistantApiDeploymentResponse}
 */
proto.assistant_api.GetAssistantApiDeploymentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAssistantApiDeploymentResponse;
  return proto.assistant_api.GetAssistantApiDeploymentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAssistantApiDeploymentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAssistantApiDeploymentResponse}
 */
proto.assistant_api.GetAssistantApiDeploymentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.assistant_api.AssistantApiDeployment;
      reader.readMessage(value,proto.assistant_api.AssistantApiDeployment.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAssistantApiDeploymentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAssistantApiDeploymentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAssistantApiDeploymentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantApiDeploymentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.assistant_api.AssistantApiDeployment.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.assistant_api.GetAssistantApiDeploymentResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.GetAssistantApiDeploymentResponse} returns this
 */
proto.assistant_api.GetAssistantApiDeploymentResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.assistant_api.GetAssistantApiDeploymentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.GetAssistantApiDeploymentResponse} returns this
 */
proto.assistant_api.GetAssistantApiDeploymentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional AssistantApiDeployment data = 3;
 * @return {?proto.assistant_api.AssistantApiDeployment}
 */
proto.assistant_api.GetAssistantApiDeploymentResponse.prototype.getData = function() {
  return /** @type{?proto.assistant_api.AssistantApiDeployment} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantApiDeployment, 3));
};


/**
 * @param {?proto.assistant_api.AssistantApiDeployment|undefined} value
 * @return {!proto.assistant_api.GetAssistantApiDeploymentResponse} returns this
*/
proto.assistant_api.GetAssistantApiDeploymentResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAssistantApiDeploymentResponse} returns this
 */
proto.assistant_api.GetAssistantApiDeploymentResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAssistantApiDeploymentResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.assistant_api.GetAssistantApiDeploymentResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.assistant_api.GetAssistantApiDeploymentResponse} returns this
*/
proto.assistant_api.GetAssistantApiDeploymentResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAssistantApiDeploymentResponse} returns this
 */
proto.assistant_api.GetAssistantApiDeploymentResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAssistantApiDeploymentResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAssistantPhoneDeploymentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAssistantPhoneDeploymentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAssistantPhoneDeploymentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantPhoneDeploymentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && proto.assistant_api.AssistantPhoneDeployment.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAssistantPhoneDeploymentResponse}
 */
proto.assistant_api.GetAssistantPhoneDeploymentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAssistantPhoneDeploymentResponse;
  return proto.assistant_api.GetAssistantPhoneDeploymentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAssistantPhoneDeploymentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAssistantPhoneDeploymentResponse}
 */
proto.assistant_api.GetAssistantPhoneDeploymentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.assistant_api.AssistantPhoneDeployment;
      reader.readMessage(value,proto.assistant_api.AssistantPhoneDeployment.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAssistantPhoneDeploymentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAssistantPhoneDeploymentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAssistantPhoneDeploymentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantPhoneDeploymentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.assistant_api.AssistantPhoneDeployment.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.assistant_api.GetAssistantPhoneDeploymentResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.GetAssistantPhoneDeploymentResponse} returns this
 */
proto.assistant_api.GetAssistantPhoneDeploymentResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.assistant_api.GetAssistantPhoneDeploymentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.GetAssistantPhoneDeploymentResponse} returns this
 */
proto.assistant_api.GetAssistantPhoneDeploymentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional AssistantPhoneDeployment data = 3;
 * @return {?proto.assistant_api.AssistantPhoneDeployment}
 */
proto.assistant_api.GetAssistantPhoneDeploymentResponse.prototype.getData = function() {
  return /** @type{?proto.assistant_api.AssistantPhoneDeployment} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantPhoneDeployment, 3));
};


/**
 * @param {?proto.assistant_api.AssistantPhoneDeployment|undefined} value
 * @return {!proto.assistant_api.GetAssistantPhoneDeploymentResponse} returns this
*/
proto.assistant_api.GetAssistantPhoneDeploymentResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAssistantPhoneDeploymentResponse} returns this
 */
proto.assistant_api.GetAssistantPhoneDeploymentResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAssistantPhoneDeploymentResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.assistant_api.GetAssistantPhoneDeploymentResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.assistant_api.GetAssistantPhoneDeploymentResponse} returns this
*/
proto.assistant_api.GetAssistantPhoneDeploymentResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAssistantPhoneDeploymentResponse} returns this
 */
proto.assistant_api.GetAssistantPhoneDeploymentResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAssistantPhoneDeploymentResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAssistantWhatsappDeploymentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAssistantWhatsappDeploymentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAssistantWhatsappDeploymentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantWhatsappDeploymentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && proto.assistant_api.AssistantWhatsappDeployment.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAssistantWhatsappDeploymentResponse}
 */
proto.assistant_api.GetAssistantWhatsappDeploymentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAssistantWhatsappDeploymentResponse;
  return proto.assistant_api.GetAssistantWhatsappDeploymentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAssistantWhatsappDeploymentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAssistantWhatsappDeploymentResponse}
 */
proto.assistant_api.GetAssistantWhatsappDeploymentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.assistant_api.AssistantWhatsappDeployment;
      reader.readMessage(value,proto.assistant_api.AssistantWhatsappDeployment.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAssistantWhatsappDeploymentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAssistantWhatsappDeploymentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAssistantWhatsappDeploymentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantWhatsappDeploymentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.assistant_api.AssistantWhatsappDeployment.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.assistant_api.GetAssistantWhatsappDeploymentResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.GetAssistantWhatsappDeploymentResponse} returns this
 */
proto.assistant_api.GetAssistantWhatsappDeploymentResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.assistant_api.GetAssistantWhatsappDeploymentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.GetAssistantWhatsappDeploymentResponse} returns this
 */
proto.assistant_api.GetAssistantWhatsappDeploymentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional AssistantWhatsappDeployment data = 3;
 * @return {?proto.assistant_api.AssistantWhatsappDeployment}
 */
proto.assistant_api.GetAssistantWhatsappDeploymentResponse.prototype.getData = function() {
  return /** @type{?proto.assistant_api.AssistantWhatsappDeployment} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantWhatsappDeployment, 3));
};


/**
 * @param {?proto.assistant_api.AssistantWhatsappDeployment|undefined} value
 * @return {!proto.assistant_api.GetAssistantWhatsappDeploymentResponse} returns this
*/
proto.assistant_api.GetAssistantWhatsappDeploymentResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAssistantWhatsappDeploymentResponse} returns this
 */
proto.assistant_api.GetAssistantWhatsappDeploymentResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAssistantWhatsappDeploymentResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.assistant_api.GetAssistantWhatsappDeploymentResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.assistant_api.GetAssistantWhatsappDeploymentResponse} returns this
*/
proto.assistant_api.GetAssistantWhatsappDeploymentResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAssistantWhatsappDeploymentResponse} returns this
 */
proto.assistant_api.GetAssistantWhatsappDeploymentResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAssistantWhatsappDeploymentResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAssistantDebuggerDeploymentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAssistantDebuggerDeploymentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAssistantDebuggerDeploymentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantDebuggerDeploymentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && proto.assistant_api.AssistantDebuggerDeployment.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAssistantDebuggerDeploymentResponse}
 */
proto.assistant_api.GetAssistantDebuggerDeploymentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAssistantDebuggerDeploymentResponse;
  return proto.assistant_api.GetAssistantDebuggerDeploymentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAssistantDebuggerDeploymentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAssistantDebuggerDeploymentResponse}
 */
proto.assistant_api.GetAssistantDebuggerDeploymentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.assistant_api.AssistantDebuggerDeployment;
      reader.readMessage(value,proto.assistant_api.AssistantDebuggerDeployment.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAssistantDebuggerDeploymentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAssistantDebuggerDeploymentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAssistantDebuggerDeploymentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantDebuggerDeploymentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.assistant_api.AssistantDebuggerDeployment.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.assistant_api.GetAssistantDebuggerDeploymentResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.GetAssistantDebuggerDeploymentResponse} returns this
 */
proto.assistant_api.GetAssistantDebuggerDeploymentResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.assistant_api.GetAssistantDebuggerDeploymentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.GetAssistantDebuggerDeploymentResponse} returns this
 */
proto.assistant_api.GetAssistantDebuggerDeploymentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional AssistantDebuggerDeployment data = 3;
 * @return {?proto.assistant_api.AssistantDebuggerDeployment}
 */
proto.assistant_api.GetAssistantDebuggerDeploymentResponse.prototype.getData = function() {
  return /** @type{?proto.assistant_api.AssistantDebuggerDeployment} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantDebuggerDeployment, 3));
};


/**
 * @param {?proto.assistant_api.AssistantDebuggerDeployment|undefined} value
 * @return {!proto.assistant_api.GetAssistantDebuggerDeploymentResponse} returns this
*/
proto.assistant_api.GetAssistantDebuggerDeploymentResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAssistantDebuggerDeploymentResponse} returns this
 */
proto.assistant_api.GetAssistantDebuggerDeploymentResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAssistantDebuggerDeploymentResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.assistant_api.GetAssistantDebuggerDeploymentResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.assistant_api.GetAssistantDebuggerDeploymentResponse} returns this
*/
proto.assistant_api.GetAssistantDebuggerDeploymentResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAssistantDebuggerDeploymentResponse} returns this
 */
proto.assistant_api.GetAssistantDebuggerDeploymentResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAssistantDebuggerDeploymentResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAssistantWebpluginDeploymentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAssistantWebpluginDeploymentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAssistantWebpluginDeploymentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantWebpluginDeploymentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && proto.assistant_api.AssistantWebpluginDeployment.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAssistantWebpluginDeploymentResponse}
 */
proto.assistant_api.GetAssistantWebpluginDeploymentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAssistantWebpluginDeploymentResponse;
  return proto.assistant_api.GetAssistantWebpluginDeploymentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAssistantWebpluginDeploymentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAssistantWebpluginDeploymentResponse}
 */
proto.assistant_api.GetAssistantWebpluginDeploymentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.assistant_api.AssistantWebpluginDeployment;
      reader.readMessage(value,proto.assistant_api.AssistantWebpluginDeployment.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAssistantWebpluginDeploymentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAssistantWebpluginDeploymentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAssistantWebpluginDeploymentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantWebpluginDeploymentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.assistant_api.AssistantWebpluginDeployment.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.assistant_api.GetAssistantWebpluginDeploymentResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.GetAssistantWebpluginDeploymentResponse} returns this
 */
proto.assistant_api.GetAssistantWebpluginDeploymentResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.assistant_api.GetAssistantWebpluginDeploymentResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.GetAssistantWebpluginDeploymentResponse} returns this
 */
proto.assistant_api.GetAssistantWebpluginDeploymentResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional AssistantWebpluginDeployment data = 3;
 * @return {?proto.assistant_api.AssistantWebpluginDeployment}
 */
proto.assistant_api.GetAssistantWebpluginDeploymentResponse.prototype.getData = function() {
  return /** @type{?proto.assistant_api.AssistantWebpluginDeployment} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantWebpluginDeployment, 3));
};


/**
 * @param {?proto.assistant_api.AssistantWebpluginDeployment|undefined} value
 * @return {!proto.assistant_api.GetAssistantWebpluginDeploymentResponse} returns this
*/
proto.assistant_api.GetAssistantWebpluginDeploymentResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAssistantWebpluginDeploymentResponse} returns this
 */
proto.assistant_api.GetAssistantWebpluginDeploymentResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAssistantWebpluginDeploymentResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.assistant_api.GetAssistantWebpluginDeploymentResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.assistant_api.GetAssistantWebpluginDeploymentResponse} returns this
*/
proto.assistant_api.GetAssistantWebpluginDeploymentResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAssistantWebpluginDeploymentResponse} returns this
 */
proto.assistant_api.GetAssistantWebpluginDeploymentResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAssistantWebpluginDeploymentResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAssistantDeploymentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAssistantDeploymentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAssistantDeploymentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantDeploymentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    assistantid: jspb.Message.getFieldWithDefault(msg, 1, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAssistantDeploymentRequest}
 */
proto.assistant_api.GetAssistantDeploymentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAssistantDeploymentRequest;
  return proto.assistant_api.GetAssistantDeploymentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAssistantDeploymentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAssistantDeploymentRequest}
 */
proto.assistant_api.GetAssistantDeploymentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAssistantDeploymentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAssistantDeploymentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAssistantDeploymentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantDeploymentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
};


/**
 * optional uint64 assistantId = 1;
 * @return {string}
 */
proto.assistant_api.GetAssistantDeploymentRequest.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.GetAssistantDeploymentRequest} returns this
 */
proto.assistant_api.GetAssistantDeploymentRequest.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


goog.object.extend(exports, proto.assistant_api);
